import React from 'react';

export const Delivery = () => (
	<svg width="39" height="37" viewBox="0 0 39 37" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clipPath="url(#clip0_1707_78444)">
			<g clipPath="url(#clip1_1707_78444)">
				<path d="M3.25 16L10 16L10 34L3.25 16Z" fill="#FDC300" />
				<rect
					width="18"
					height="28.5"
					transform="matrix(4.37114e-08 1 1 -4.37114e-08 10 16)"
					fill="#FDC300"
				/>
			</g>
		</g>
		<g clipPath="url(#clip2_1707_78444)">
			<mask id="path-3-inside-1_1707_78444" fill="white">
				<rect x="4" y="5.5" width="21.75" height="21.75" rx="1.5" />
			</mask>
			<rect x="4" y="5.5" width="21.75" height="21.75" rx="1.5" fill="#B8CAC4" />
			<path
				d="M13.9375 12.75C13.9375 13.2678 14.3572 13.6875 14.875 13.6875C15.3928 13.6875 15.8125 13.2678 15.8125 12.75H13.9375ZM13.9375 5.5V12.75H15.8125V5.5L13.9375 5.5Z"
				fill="#21282B"
			/>
		</g>
		<rect
			x="4"
			y="5.5"
			width="21.75"
			height="21.75"
			rx="1.5"
			stroke="#21282B"
			strokeWidth="3.75"
			strokeLinejoin="round"
			mask="url(#path-3-inside-1_1707_78444)"
		/>
		<path
			d="M25.75 12.8125H24.8125V13.75V25V25.9375H25.75H31.75C32.682 25.9375 33.4375 25.182 33.4375 24.25L33.4375 20.3785C33.4374 19.788 33.2734 19.2092 32.9636 18.7064L29.8262 13.6147C29.5189 13.1161 28.9752 12.8125 28.3895 12.8125H25.75Z"
			fill="white"
			stroke="#21282B"
			strokeWidth="1.875"
		/>
		<path
			d="M25.75 12.8125H24.8125V13.75V17.5V18.4375H25.75H29.125H31H32.6338L31.8094 17.0269L29.8349 13.6485L29.0255 14.1216L29.8349 13.6485C29.5323 13.1308 28.9776 12.8125 28.378 12.8125H25.75Z"
			fill="white"
			stroke="#21282B"
			strokeWidth="1.875"
		/>
		<path d="M23.875 19.375H28.0002V25.0001H23.875V19.375Z" fill="white" />
		<circle
			cx="11.875"
			cy="26.875"
			r="3.1875"
			fill="white"
			stroke="#21282B"
			strokeWidth="1.875"
			strokeLinejoin="round"
		/>
		<circle
			cx="26.125"
			cy="26.875"
			r="3.1875"
			fill="white"
			stroke="#21282B"
			strokeWidth="1.875"
			strokeLinejoin="round"
		/>
		<defs>
			<clipPath id="clip0_1707_78444">
				<rect width="34.5" height="18" fill="white" transform="translate(4 16)" />
			</clipPath>
			<clipPath id="clip1_1707_78444">
				<rect
					width="18"
					height="35.25"
					fill="white"
					transform="matrix(4.37114e-08 1 1 -4.37114e-08 3.25 16)"
				/>
			</clipPath>
			<clipPath id="clip2_1707_78444">
				<rect x="4" y="5.5" width="21.75" height="21.75" rx="1.5" fill="white" />
			</clipPath>
		</defs>
	</svg>
);
